import React from 'react';
import {
  BeyondRewardsHeading,
  StyledCard,
  StyledPhoneImage,
  StyledTextLink,
} from './GetBeyondBanner.styles';
import BeyondImageNoDDLarge from '@/src/resources/beyond/beyond-mockup-no-dd-large.png';

import { breakpoints } from '@/src/utils/mediaQuery';
import styled from 'styled-components';
import { Button, theme } from '@ovotech/element-v5';
import {
  DD_SETUP_URL,
  OVO_BEYOND_URL,
} from '@/src/components/Banners/GetBeyondBanner/constants';
import { useAnalytics } from '@ovotech/ui-tools';
import { BEYOND_BANNER } from '@/src/constants/analytics';
import { useBeyondWebTestVariant } from '@/src/components/Banners/GetBeyondBanner/useBeyondWebTestVariant';
import { useBeyondAccountFlags } from '@/src/hooks/useBeyondAccountFlags/useBeyondAccountFlags';

const ButtonsContainer = styled.div`
  display: flex;
  justify-items: center;
  align-items: center;
  gap: ${theme.space['600']};

  @media ${breakpoints.mediumDown} {
    flex-direction: column;
  }
`;

const SetupDDText = styled.p`
  font-size: ${theme.font.size.md.mediaQuery.lg};
  font-weight: ${theme.font.weight.book};
  line-height: ${theme.font.lineHeight.md.mediaQuery};
  letter-spacing: ${theme.font.letterSpacing.md.mediaQuery};
  margin-bottom: ${theme.space['550']};
  margin-top: ${theme.space['550']};

  @media ${breakpoints.mediumUp} {
    width: 45%;
    margin-bottom: 41px;
    margin-top: 41px;
  }
`;

const StyledCTAButton = styled(Button)`
  color: ${theme.color.neutral.white};
  @media ${breakpoints.mediumUp} {
    max-width: 187px;
  }
`;

export const NoDDBanner = () => {
  const { dispatch } = useAnalytics();
  const testVariant = useBeyondWebTestVariant();
  const { beyondStatus } = useBeyondAccountFlags();

  const onDDButtonClicked = () => {
    window.open(DD_SETUP_URL, '_blank', 'noopener,noreferrer');
    dispatch({
      name: BEYOND_BANNER.NO_DD.CLICKED_SET_UP_DD,
      type: 'click',
      properties: {
        ...(beyondStatus && { 'Beyond Status': beyondStatus }),
        ...(testVariant && { 'Test variant': testVariant }),
      },
    });
  };

  const onBeyondRewardsClicked = () => {
    dispatch({
      name: BEYOND_BANNER.NO_DD.CLICKED_BEYOND_REWARDS,
      type: 'click',
      properties: {
        ...(beyondStatus && { 'Beyond Status': beyondStatus }),
        ...(testVariant && { 'Test variant': testVariant }),
      },
    });
  };

  return (
    <StyledCard variant="green">
      <BeyondRewardsHeading />
      <SetupDDText>
        Set up a Direct Debit to unlock rewards in the OVO app.
      </SetupDDText>

      <ButtonsContainer>
        <StyledCTAButton
          variant="outline-variant"
          inverted
          fullWidth
          onClick={onDDButtonClicked}
        >
          Set up Direct Debit
        </StyledCTAButton>
        <StyledTextLink
          opensInNewWindow
          variant={'outline'}
          href={OVO_BEYOND_URL}
          inverted
          onClick={onBeyondRewardsClicked}
        >
          Beyond Rewards
        </StyledTextLink>
      </ButtonsContainer>
      <StyledPhoneImage src={BeyondImageNoDDLarge} aria-hidden hideOnMobile />
    </StyledCard>
  );
};
